<template>
  <div>
    <div class="row mb-1">
      <div class="col-md-12">
        <button
          class="btn btn-primary"
          data-toggle="modal"
          data-target="#importDevices"
        >
          Buscar Dispositivos do Pulsus
        </button>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-12">
        <base-crud
          :ref="'deviceCrud'"
          :crudName="$t('Devices')"
          :newText="$t('Add') + '  ' + $t('New')"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
          :customFilters="customFilters"
          @filtered_ds="filtered_ds"
        >
        </base-crud>
      </div>
    </div>

    <div
      class="modal fade"
      id="importDevices"
      data-backdrop="true"
      data-keyboard="true"
      tabindex="-1"
      aria-labelledby="importDevicesLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered pulsus-modal-dialog">
        <div class="modal-content pulsus-modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="importDevicesLabel">
              Vincular Dispositivos do Pulsus
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body pulsus-modal-body">
            <div class="row">
              <div class="col-md-6">
                <label>Selecione a central</label>
                <select class="form-control" v-model="center_selected" @change="onCenterChange">
                  <option value="">Selecione...</option>
                  <option
                    v-for="center in centers"
                    :key="center.id"
                    :value="center.id"
                  >
                    {{ center.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-6 mt-2">
                <button
                  class="btn btn-primary"
                  @click="getDevicesPulsus"
                  :disabled="!center_selected || isLoadingPulsusDevices"
                >
                  {{ isLoadingPulsusDevices ? "Buscando..." : "Buscar Dispositivos" }}
                </button>
              </div>
            </div>

            <div class="row mt-3" v-if="isLoadingPulsusDevices">
              <div class="col-md-12">
                <div class="alert alert-info mb-0 d-flex align-items-center">
                  <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                  <span>Carregando dispositivos do Pulsus...</span>
                </div>
              </div>
            </div>

            <div class="row mt-3" v-else-if="hasSearchedPulsus && devices_pulsus.length">
              <div class="col-md-12 mb-2">
                <div class="pulsus-summary-bar">
                  <div class="pulsus-summary-chip">
                    <span class="chip-label">Pendentes</span>
                    <span class="chip-value">{{ devices_pulsus.length }}</span>
                  </div>
                  <div class="pulsus-summary-chip">
                    <span class="chip-label">Filtrados</span>
                    <span class="chip-value">{{ filteredPulsusDevices.length }}</span>
                  </div>
                  <div class="pulsus-summary-chip">
                    <span class="chip-label">Com veiculo</span>
                    <span class="chip-value">{{ selectedCount }}</span>
                  </div>
                  <div class="pulsus-summary-chip">
                    <span class="chip-label">Confirmados</span>
                    <span class="chip-value">{{ confirmedCount }}</span>
                  </div>
                  <div class="pulsus-summary-chip pulsus-summary-chip--ok">
                    <span class="chip-label">Prontos</span>
                    <span class="chip-value">{{ readyToLinkCount }}</span>
                  </div>
                  <div class="pulsus-summary-chip pulsus-summary-chip--fail">
                    <span class="chip-label">Falhas</span>
                    <span class="chip-value">{{ failedCount }}</span>
                  </div>
                  <div class="pulsus-summary-actions">
                    <button
                      class="btn btn-sm btn-outline-primary"
                      :disabled="!filteredPulsusDevices.length"
                      @click="setConfirmForVisible(true)"
                    >
                      Confirmar visiveis
                    </button>
                    <button
                      class="btn btn-sm btn-outline-secondary"
                      :disabled="!filteredPulsusDevices.length"
                      @click="setConfirmForVisible(false)"
                    >
                      Limpar confirmacoes
                    </button>
                    <button
                      class="btn btn-sm btn-outline-danger"
                      :class="{ active: showOnlyFailed }"
                      :disabled="!failedCount"
                      @click="showOnlyFailed = !showOnlyFailed"
                    >
                      {{ showOnlyFailed ? "Mostrar todos" : "Somente falhas" }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="pulsus-devices-table">
                  <table class="table table-sm table-striped table-bordered mb-0 pulsus-table">
                    <thead>
                      <tr>
                        <th>Nome</th>
                        <th>Identificador</th>
                        <th>Modelo</th>
                        <th>Status</th>
                        <th class="col-vehicle">Veiculo para vinculo</th>
                        <th>Confirmacao</th>
                        <th>Acoes</th>
                      </tr>
                      <tr>
                        <th>
                          <input
                            v-model.trim="pulsusFilters.name"
                            type="text"
                            class="form-control form-control-sm"
                            placeholder="Pesquisar nome"
                          />
                        </th>
                        <th>
                          <input
                            v-model.trim="pulsusFilters.identifier"
                            type="text"
                            class="form-control form-control-sm"
                            placeholder="Pesquisar identificador"
                          />
                        </th>
                        <th>
                          <input
                            v-model.trim="pulsusFilters.model"
                            type="text"
                            class="form-control form-control-sm"
                            placeholder="Pesquisar modelo"
                          />
                        </th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="device in filteredPulsusDevices"
                        :key="device.id"
                        :class="getPulsusRowClass(device.id)"
                      >
                        <td>
                          <span v-if="failedByDevice[device.id]" class="pulsus-fail-icon" title="Falha no ultimo vinculo">!</span>
                          {{ getPulsusDeviceName(device) }}
                        </td>
                        <td>{{ device.identifier || "-" }}</td>
                        <td>{{ device.model || "-" }}</td>
                        <td>{{ device.status || "-" }}</td>
                        <td class="col-vehicle">
                          <v-select
                            :options="vehicleOptions"
                            :reduce="(vehicle) => vehicle.id"
                            :label="'label'"
                            :value="selectedVehiclesByDevice[device.id]"
                            :clearable="true"
                            :append-to-body="false"
                            class="vselect vehicle-select"
                            placeholder="Pesquise por nome ou placa..."
                            @input="onVehicleSelect(device.id, $event)"
                          />
                          <small
                            v-if="selectionSourceByDevice[device.id] === 'auto'"
                            class="text-info"
                          >Auto selecionado por nome</small>
                          <small
                            v-else-if="selectionSourceByDevice[device.id] === 'manual'"
                            class="text-primary"
                          >Selecionado manualmente</small>
                        </td>
                        <td class="text-center">
                          <label class="pulsus-confirm-check">
                            <input
                              type="checkbox"
                              :disabled="!selectedVehiclesByDevice[device.id]"
                              v-model="confirmByDevice[device.id]"
                            />
                            <span>Revisado</span>
                          </label>
                          <small
                            v-if="selectionSourceByDevice[device.id] === 'auto' && !confirmByDevice[device.id]"
                            class="text-warning d-block"
                          >
                            Revise sugestao automatica
                          </small>
                        </td>
                        <td>
                          <button
                            class="btn btn-sm btn-success"
                            :disabled="!selectedVehiclesByDevice[device.id] || !confirmByDevice[device.id] || linkingByDevice[device.id]"
                            @click="linkPulsusDevice(device)"
                          >
                            {{ linkingByDevice[device.id] ? "Vinculando..." : "Vincular" }}
                          </button>
                          <small
                            v-if="linkedByDevice[device.id]"
                            class="text-success d-block"
                          >Vinculado</small>
                          <small
                            v-if="failedByDevice[device.id]"
                            class="text-danger d-block"
                            :title="failureReasonByDevice[device.id]"
                          >Falhou: {{ failureReasonByDevice[device.id] }}</small>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="row mt-3" v-else-if="hasSearchedPulsus">
              <div class="col-md-12">
                <div class="alert alert-warning mb-0">Nenhum dispositivo encontrado para a central selecionada.</div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="isBatchLinking || !hasAnySelection"
              @click="linkSelectedDevices"
            >
              {{ isBatchLinking ? "Vinculando..." : "Vincular selecionados" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  data: function () {
    return {
      customFilters: [
        {
          name: "acquisition_date_f",
          type: "calendar",
          call: "filtered_ds",
        },
      ],
      center_selected: null,
      acquisition_date: "",
      table: "deviceTable",
      showMessageImport: false,
      deviceCrud: {},
      pages: [],
      devices_pulsus: [],
      centers: [],
      vehicles: [],
      suppliers: [],
      deviceModels: [],
      selectedVehiclesByDevice: {},
      selectionSourceByDevice: {},
      confirmByDevice: {},
      linkedByDevice: {},
      linkingByDevice: {},
      failedByDevice: {},
      failureReasonByDevice: {},
      showOnlyFailed: false,
      linkedPulsusById: {},
      linkedPulsusByIdentifier: {},
      isBatchLinking: false,
      hasCrudChanges: false,
      pulsusFilters: {
        name: "",
        identifier: "",
        model: "",
      },
      hasSearchedPulsus: false,
      isLoadingPulsusDevices: false,
      url: "",
      columns: [
        "id",
        "unit_id",
        "supplier_id",
        "device_model_id",
        "imei",
        "acquisition_date_f",
        "assignment",
        "actions",
      ],
      tableData: [
        "id",
        "unit_id",
        "supplier_id",
        "device_model_id",
        "imei",
        "acquisition_date",
      ],
      optionsOrigin: {
        filterByColumn: true,
        debounce: 1000,
        sortable: [
          "id",
          "device_model_id",
          "supplier_id",
          "unit_id",
          "imei",
          "acquisition_date_f",
        ],
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down",
        },
        pagination: {
          chunk: 10,
          dropdown: false,
          nav: "scroll",
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: this.$t("id"),
          unit_id: this.$t("Unit"),
          supplier_id: this.$t("Supplier"),
          device_model_id: this.$t("Device Model"),
          imei: this.$t("Imei"),
          acquisition_date: this.$t("acquisition date"),
          assignment: this.$t("Assignment"),
          actions: this.$t("action"),
        },
        texts: {
          filterBy: this.$t("Filter"),
          defaultOption: this.$t("Select"),
        },
        listColumns: {
          unit_id: [],
          supplier_id: [],
          device_model_id: [],
        },
        templates: {
          supplier_id: function (h, row, index) {
            return row.supplier?.name ?? "";
          },
          center_id: function (h, row, index) {
            return row.center?.name ?? "";
          },
          unit_id: function (h, row, index) {
            return row.unit?.name ?? "";
          },
          device_model_id: function (h, row, index) {
            return row.device_model?.name ?? "";
          },
          chip_id: function (h, row, index) {
            return row.chip?.operator?.name ?? "";
          },
          assignment: function (h, row, index) {
            const vehicleAssignment = row.active_assignment?.vehicle_assignment;
            const vehicleName = vehicleAssignment?.vehicle?.name || null;
            const label = vehicleName
              ? vehicleName
              : row.$t
              ? row.$t("Not assigned")
              : "Não atribuído";
            return label;
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;

          if (
            this.$parent.$parent.$parent.acquisition_date != null &&
            this.$parent.$parent.$parent.acquisition_date != ""
          ) {
            requestData.params.acquisition_date =
              this.$parent.$parent.$parent.acquisition_date;
          }

          requestData.params.query = "";
          requestData.params.with = [
            "supplier",
            "center",
            "unit",
            "deviceModel",
            "chip",
            "activeAssignment.vehicleAssignment.vehicle",
          ];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this),
          );
        },
      },
      endPoint: "devices",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
    vSelect,
  },
  computed: {
    options() {
      const headings = {
        id: this.$t("id"),
        unit_id: this.$t("Unit"),
        supplier_id: this.$t("Supplier"),
        device_model_id: this.$t("Device Model"),
        imei: this.$t("IMEI"),
        acquisition_date_f: this.$t("acquisition date"),
        assignment: this.$t("Assignment"),
        actions: this.$t("action"),
      };

      const texts = {
        filterBy: this.$t("Filter"),
        defaultOption: this.$t("Select"),
      };
      return {
        ...this.optionsOrigin,
        texts,
        headings,
      };
    },
    filteredPulsusDevices() {
      const nameFilter = this.normalizeText(this.pulsusFilters.name || "");
      const identifierFilter = this.normalizeText(this.pulsusFilters.identifier || "");
      const modelFilter = this.normalizeText(this.pulsusFilters.model || "");

      return this.devices_pulsus.filter((device) => {
        const deviceName = this.normalizeText(this.getPulsusDeviceName(device));
        const identifier = this.normalizeText(device.identifier || "");
        const model = this.normalizeText(device.model || "");

        const matchName = !nameFilter || deviceName.includes(nameFilter);
        const matchIdentifier = !identifierFilter || identifier.includes(identifierFilter);
        const matchModel = !modelFilter || model.includes(modelFilter);
        const matchFailed = !this.showOnlyFailed || !!this.failedByDevice[device.id];

        return matchName && matchIdentifier && matchModel && matchFailed;
      });
    },
    vehicleOptions() {
      return this.vehicles.map((vehicle) => ({
        ...vehicle,
        label: `${vehicle.name || "Sem nome"}${vehicle.license_plate ? ` - ${vehicle.license_plate}` : ""}`,
      }));
    },
    hasAnySelection() {
      return this.devices_pulsus.some(
        (device) => !!this.selectedVehiclesByDevice[device.id] && !!this.confirmByDevice[device.id],
      );
    },
    selectedCount() {
      return this.devices_pulsus.filter((device) => !!this.selectedVehiclesByDevice[device.id]).length;
    },
    confirmedCount() {
      return this.devices_pulsus.filter((device) => !!this.confirmByDevice[device.id]).length;
    },
    readyToLinkCount() {
      return this.devices_pulsus.filter(
        (device) => !!this.selectedVehiclesByDevice[device.id] && !!this.confirmByDevice[device.id],
      ).length;
    },
    failedCount() {
      return this.devices_pulsus.filter((device) => !!this.failedByDevice[device.id]).length;
    },
  },
  methods: {
    setConfirmForVisible(value) {
      this.filteredPulsusDevices.forEach((device) => {
        const hasVehicle = !!this.selectedVehiclesByDevice[device.id];
        this.$set(this.confirmByDevice, device.id, hasVehicle ? !!value : false);
      });
    },
    refreshCrudTable() {
      const baseCrud = this.$refs.deviceCrud;
      const tableRef = baseCrud && baseCrud.$refs ? baseCrud.$refs.table : null;

      if (tableRef && typeof tableRef.refresh === "function") {
        tableRef.refresh();
      }
    },
    onImportModalHidden() {
      if (this.hasCrudChanges) {
        this.refreshCrudTable();
        this.hasCrudChanges = false;
      }
    },
    markDeviceAsFailed(deviceId, reason) {
      this.$set(this.failedByDevice, deviceId, true);
      this.$set(this.failureReasonByDevice, deviceId, reason || "Falha nao informada");
    },
    clearDeviceFailure(deviceId) {
      this.$set(this.failedByDevice, deviceId, false);
      this.$set(this.failureReasonByDevice, deviceId, "");
    },
    formatBatchFailures(results, selectedDevices) {
      const failures = (results || [])
        .map((result, index) => {
          if (result?.ok) return null;
          const device = selectedDevices[index];
          const name = device ? this.getPulsusDeviceName(device) : `Item ${index + 1}`;
          const identifier = device?.identifier || "-";
          const reason = result?.error || "Erro nao informado";
          return `- ${name} (${identifier}): ${reason}`;
        })
        .filter(Boolean);

      if (!failures.length) return "";

      const preview = failures.slice(0, 5).join("\n");
      const suffix = failures.length > 5 ? `\n... e mais ${failures.length - 5} falha(s).` : "";

      return `${preview}${suffix}`;
    },
    getCenters() {
      let api = this.$store.state.api + "centers/";
      axios
        .get(api)
        .then((response) => {
          this.centers = response.data.data || [];
          if (this.centers.length && !this.center_selected) {
            this.center_selected = this.centers[0].id;
            this.onCenterChange();
          }
        })
        .catch((error) => {
          this.$error(error);
        });
    },
    onCenterChange() {
      if (!this.center_selected) {
        return;
      }
    },
    getSelectedCenter() {
      return this.centers.find((center) => Number(center.id) === Number(this.center_selected)) || null;
    },
    async getDevicesPulsus() {
      if (!this.center_selected) {
        this.$message("Aviso", "Selecione uma central antes de buscar.", "warning");
        return;
      }

      this.isLoadingPulsusDevices = true;
      this.hasSearchedPulsus = false;
      try {
        await this.refreshLinkedPulsusIndex();

        let api = this.$store.state.api + "get-pulsus-devices/";
        const response = await axios.post(api, { center_id: this.center_selected });
        const payload = response.data?.data || response.data;
        const devices = Array.isArray(payload) ? payload : [];
        const pendingDevices = this.filterOutAlreadyLinkedPulsusDevices(devices);

        this.devices_pulsus = pendingDevices;
        this.selectedVehiclesByDevice = {};
        this.selectionSourceByDevice = {};
        this.confirmByDevice = {};
        this.linkedByDevice = {};
        this.linkingByDevice = {};
        this.failedByDevice = {};
        this.failureReasonByDevice = {};
        this.showOnlyFailed = false;

        pendingDevices.forEach((device) => {
          this.$set(this.selectedVehiclesByDevice, device.id, null);
          this.$set(this.selectionSourceByDevice, device.id, null);
          this.$set(this.confirmByDevice, device.id, false);
          this.$set(this.linkedByDevice, device.id, false);
          this.$set(this.linkingByDevice, device.id, false);
          this.$set(this.failedByDevice, device.id, false);
          this.$set(this.failureReasonByDevice, device.id, "");
          this.autoSelectVehicleForDevice(device);
        });

        this.hasSearchedPulsus = true;

        if (devices.length > 0 && pendingDevices.length === 0) {
          this.$message("Info", "Todos os dispositivos retornados ja estao vinculados.", "info");
        }
      } catch (error) {
        this.$error(error);
      } finally {
        this.isLoadingPulsusDevices = false;
      }
    },
    async refreshLinkedPulsusIndex() {
      try {
        const selectedCenterId = Number(this.center_selected);
        const response = await axios.get(`${this.$store.state.api}devices`, {
          params: {
            paginated: false,
            center_id: this.center_selected,
          },
        });

        const payload = response.data?.data || response.data || [];
        const localDevices = Array.isArray(payload) ? payload : [];
        const byId = {};
        const byIdentifier = {};

        localDevices.forEach((localDevice) => {

          if (selectedCenterId && Number(localDevice.center_id) !== selectedCenterId) {
            return;
          }

          if (localDevice.pulsus_device_id !== null && localDevice.pulsus_device_id !== undefined && localDevice.pulsus_device_id !== "") {
            byId[String(localDevice.pulsus_device_id)] = true;
          }

          const imei = this.normalizeText(localDevice.imei || "");
          if (imei) {
            byIdentifier[imei] = true;
          }
        });

        this.linkedPulsusById = byId;
        this.linkedPulsusByIdentifier = byIdentifier;
      } catch (error) {
        this.linkedPulsusById = {};
        this.linkedPulsusByIdentifier = {};
      }
    },
    isPulsusDeviceAlreadyLinked(device) {
      if (!device) {
        return false;
      }

      const pulsusId = device.id;
      if (pulsusId !== null && pulsusId !== undefined && this.linkedPulsusById[String(pulsusId)]) {
        return true;
      }

      const normalizedIdentifier = this.normalizeText(device.identifier || "");
      return !!(normalizedIdentifier && this.linkedPulsusByIdentifier[normalizedIdentifier]);
    },
    filterOutAlreadyLinkedPulsusDevices(devices) {
      return (devices || []).filter((device) => !this.isPulsusDeviceAlreadyLinked(device));
    },
    registerPulsusAsLinked(pulsusDevice, localDevice) {
      if (pulsusDevice?.id !== null && pulsusDevice?.id !== undefined) {
        this.$set(this.linkedPulsusById, String(pulsusDevice.id), true);
      }

      const identifier = this.normalizeText(pulsusDevice?.identifier || localDevice?.imei || "");
      if (identifier) {
        this.$set(this.linkedPulsusByIdentifier, identifier, true);
      }
    },
    removePulsusDeviceFromList(pulsusDeviceId) {
      this.devices_pulsus = this.devices_pulsus.filter(
        (current) => Number(current.id) !== Number(pulsusDeviceId),
      );
      this.$delete(this.selectedVehiclesByDevice, pulsusDeviceId);
      this.$delete(this.selectionSourceByDevice, pulsusDeviceId);
      this.$delete(this.confirmByDevice, pulsusDeviceId);
      this.$delete(this.linkedByDevice, pulsusDeviceId);
      this.$delete(this.linkingByDevice, pulsusDeviceId);
      this.$delete(this.failedByDevice, pulsusDeviceId);
      this.$delete(this.failureReasonByDevice, pulsusDeviceId);
    },
    getVehicles() {
      let api = this.$store.state.api + "vehicles?paginated=false&status=1";
      axios
        .get(api)
        .then((response) => {
          const vehicles = response.data.data || response.data || [];
          this.vehicles = vehicles.filter((vehicle) => this.isVehicleActive(vehicle));
          this.devices_pulsus.forEach((device) => {
            this.autoSelectVehicleForDevice(device);
          });
        })
        .catch((error) => {
          this.$error(error);
        });
    },
    isVehicleActive(vehicle) {
      const status = vehicle?.status;
      if (status === null || status === undefined || status === "") {
        return true;
      }

      const normalized = String(status).toLowerCase();
      return normalized === "active" || normalized === "1" || normalized === "true";
    },
    onVehicleSelect(deviceId, vehicleId) {
      this.$set(this.selectedVehiclesByDevice, deviceId, vehicleId || null);
      this.$set(this.selectionSourceByDevice, deviceId, vehicleId ? "manual" : null);
      this.$set(this.confirmByDevice, deviceId, false);
      this.clearDeviceFailure(deviceId);
    },
    normalizeText(value) {
      return String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();
    },
    autoSelectVehicleForDevice(device) {
      if (!device || !device.id || !this.vehicles.length) {
        return;
      }

      const source = this.selectionSourceByDevice[device.id];
      if (source === "manual") {
        return;
      }

      const deviceName = this.normalizeText(this.getPulsusDeviceName(device));
      if (!deviceName) {
        return;
      }

      const matched = this.vehicles.filter((vehicle) => this.normalizeText(vehicle.name) === deviceName);

      if (matched.length === 1) {
        this.$set(this.selectedVehiclesByDevice, device.id, matched[0].id);
        this.$set(this.selectionSourceByDevice, device.id, "auto");
        this.$set(this.confirmByDevice, device.id, false);
      }
    },
    getPulsusRowClass(deviceId) {
      return {
        "table-danger": !!this.failedByDevice[deviceId] && !this.linkedByDevice[deviceId],
        "table-success": !!this.linkedByDevice[deviceId],
        "table-info": !!this.selectedVehiclesByDevice[deviceId] && !this.linkedByDevice[deviceId] && !this.failedByDevice[deviceId],
      };
    },
    getVehicleById(vehicleId) {
      return this.vehicles.find((vehicle) => Number(vehicle.id) === Number(vehicleId)) || null;
    },
    extractDeviceImei(pulsusDevice) {
      return pulsusDevice.identifier || null;
    },
    /**
     * Monta o payload de um item para a API batch.
     */
    buildLinkPayload(device, vehicleId) {
      const firstName = device?.user?.first_name ? String(device.user.first_name).trim() : "";
      const lastName  = device?.user?.last_name  ? String(device.user.last_name).trim()  : "";
      const fullName  = `${firstName} ${lastName}`.trim();

      return {
        vehicle_id:       vehicleId,
        imei:             this.extractDeviceImei(device),
        pulsus_device_id: device.id ?? null,
        manufacturer:     device.manufacturer || null,
        model:            device.model        || null,
        platform:         device.platform     || null,
        serial_number:    device.serial_number || null,
        activated_at:     device.activated_at ? String(device.activated_at).slice(0, 10) : null,
        pulsus_name:      fullName || device.identifier || null,
      };
    },
    /**
     * Vincula um único dispositivo Pulsus via a API batch (1 request).
     */
    async linkPulsusDevice(device, options = {}) {
      const { silent = false } = options;
      const vehicleId = this.selectedVehiclesByDevice[device.id];

      if (!vehicleId) {
        if (!silent) this.$message("Aviso", "Selecione um veiculo para vinculo.", "warning");
        return { ok: false, reason: "vehicle-not-selected" };
      }
      if (!this.confirmByDevice[device.id]) {
        if (!silent) this.$message("Aviso", "Confirme o vinculo antes de continuar.", "warning");
        return { ok: false, reason: "not-confirmed" };
      }
      if (!device.identifier) {
        if (!silent) this.$message("Erro", "Dispositivo sem IMEI/identificador.", "error");
        return { ok: false, reason: "no-imei" };
      }

      this.$set(this.linkingByDevice, device.id, true);
      try {
        const response = await axios.post(
          `${this.$store.state.api}devices/batch-link-pulsus`,
          { items: [this.buildLinkPayload(device, vehicleId)] },
        );
        const result = response.data?.data?.results?.[0];

        if (result?.ok) {
          this.clearDeviceFailure(device.id);
          this.registerPulsusAsLinked(device, { imei: device.identifier });
          this.hasCrudChanges = true;
          this.$set(this.linkedByDevice, device.id, true);
          this.removePulsusDeviceFromList(device.id);
          if (!silent) {
            this.$message("Sucesso", `Dispositivo ${this.getPulsusDeviceName(device)} vinculado.`, "success");
          }
          return { ok: true };
        } else {
          const msg = result?.error || "Falha ao vincular dispositivo.";
          this.markDeviceAsFailed(device.id, msg);
          if (!silent) this.$message("Erro", msg, "error");
          return { ok: false, reason: msg };
        }
      } catch (error) {
        const message = error?.response?.data?.message || error?.message || "Falha ao vincular dispositivo.";
        this.markDeviceAsFailed(device.id, message);
        if (!silent) this.$message("Erro", message, "error");
        return { ok: false, reason: message };
      } finally {
        this.$set(this.linkingByDevice, device.id, false);
      }
    },
    /**
     * Vincula todos os dispositivos selecionados e confirmados em 1 única requisição.
     */
    async linkSelectedDevices() {
      const selectedDevices = this.filteredPulsusDevices.filter(
        (device) => !!this.selectedVehiclesByDevice[device.id] && !!this.confirmByDevice[device.id],
      );

      if (!selectedDevices.length) {
        this.$message("Aviso", "Selecione ao menos um dispositivo para vincular.", "warning");
        return;
      }

      this.isBatchLinking = true;
      try {
        const items = selectedDevices.map((device) =>
          this.buildLinkPayload(device, this.selectedVehiclesByDevice[device.id]),
        );

        const response = await axios.post(
          `${this.$store.state.api}devices/batch-link-pulsus`,
          { items },
        );

        const results  = response.data?.data?.results ?? [];
        const summary  = response.data?.data?.summary  ?? {};

        results.forEach((result, index) => {
          const device = selectedDevices[index];
          if (result.ok && device) {
            this.clearDeviceFailure(device.id);
            this.registerPulsusAsLinked(device, { imei: device.identifier });
            this.$set(this.linkedByDevice, device.id, true);
            this.removePulsusDeviceFromList(device.id);
            this.hasCrudChanges = true;
          } else if (device) {
            this.markDeviceAsFailed(device.id, result?.error || "Falha ao vincular dispositivo.");
          }
        });

        const successCount = summary.success ?? results.filter((r) => r.ok).length;
        const errorCount   = summary.errors  ?? results.filter((r) => !r.ok).length;
        const failureDetails = this.formatBatchFailures(results, selectedDevices);

        if (successCount > 0 && errorCount === 0) {
          this.$message("Sucesso", `${successCount} dispositivo(s) vinculado(s) com sucesso.`, "success");
          $("#importDevices").modal("hide");
        } else if (successCount > 0) {
          const msg = `${successCount} vinculado(s) e ${errorCount} com falha.\n\nFalhas:\n${failureDetails}`;
          this.$message("Aviso", msg, "warning");
        } else {
          const msg = `Nao foi possivel vincular os dispositivos selecionados.\n\nFalhas:\n${failureDetails}`;
          this.$message("Erro", msg, "error");
        }
      } catch (error) {
        const message = error?.response?.data?.message || error?.message || "Erro ao vincular dispositivos.";
        selectedDevices.forEach((device) => {
          this.markDeviceAsFailed(device.id, message);
        });
        this.$message("Erro", message, "error");
      } finally {
        this.isBatchLinking = false;
      }
    },
    getPulsusDeviceName(device) {
      const firstName = device?.user?.first_name ? String(device.user.first_name).trim() : "";
      const lastName = device?.user?.last_name ? String(device.user.last_name).trim() : "";
      const fullName = `${firstName} ${lastName}`.trim();

      if (fullName) {
        return fullName;
      }

      return device?.identifier || `ID ${device?.id || "-"}`;
    },
    filtered_ds(date) {
      this.acquisition_date = date;
    },
    query: function (query) {
      let columns = {
        id: "id",
        center_id: "center_id",
        unit_id: "unit_id",
        supplier_id: "supplier_id",
        device_model_id: "device_model_id",
        chip_id: "chip_id",
        imei: "imei",
        firmware: "firmware",
        acquisition_date_f: "acquisition_date",
        assignment: "assignment",
      };

      let filters = "";

      $.each(query, function (index, value) {
        if (value) {
          if (index === "acquisition_date_f" && value.includes("/")) {
            const [dia, mes, ano] = value.split("/");
            value = `${ano}-${mes}-${dia}`;
          }
          filters += columns[index] + "=" + value + "&";
        }
      });
      return filters;
    },
  },
  mounted() {
    $("#importDevices").on("hidden.bs.modal", this.onImportModalHidden);

    this.getCenters();
    this.getVehicles();

    let apiSuppliers = this.$store.state.api + "suppliers";
    axios
      .get(apiSuppliers)
      .then((res) => {
        const suppliers = res.data.data || res.data;
        this.suppliers = suppliers;
        this.optionsOrigin.listColumns.supplier_id = suppliers.map((f) => ({
          id: f.id,
          text: f.name,
        }));
      })
      .catch((err) => {
        console.error("Error loading suppliers:", err);
      });

    let apiDeviceModels = this.$store.state.api + "deviceModels";
    axios
      .get(apiDeviceModels)
      .then((res) => {
        const deviceModels = res.data.data || res.data;
        this.deviceModels = deviceModels;
        this.optionsOrigin.listColumns.device_model_id = deviceModels.map(
          (f) => ({
            id: f.id,
            text: f.name,
          }),
        );
      })
      .catch((err) => {
        console.error("Error loading Device Models:", err);
      });

    let apiUnits = this.$store.state.api + "units";
    axios
      .get(apiUnits)
      .then((res) => {
        const units = res.data.data || res.data;
        this.optionsOrigin.listColumns.unit_id = units.map((f) => ({
          id: f.id,
          text: f.name,
        }));
      })
      .catch((err) => {
        console.error("Error loading Units:", err);
      });
  },
  beforeDestroy() {
    $("#importDevices").off("hidden.bs.modal", this.onImportModalHidden);
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.pulsus-modal-dialog {
  width: 96vw !important;
  max-width: 96vw !important;
}

.pulsus-modal-content {
  min-height: 92vh;
}

.pulsus-modal-body {
  max-height: none;
}

.pulsus-summary-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  border: 1px solid #d9dee5;
  border-radius: 8px;
  padding: 10px;
  background: linear-gradient(90deg, #f7fafc 0%, #eef6ff 100%);
}

.pulsus-summary-chip {
  min-width: 108px;
  border: 1px solid #d9dee5;
  border-radius: 8px;
  padding: 6px 10px;
  background-color: #ffffff;
}

.pulsus-summary-chip--ok {
  border-color: #b8e7c9;
  background-color: #f2fff7;
}

.pulsus-summary-chip--fail {
  border-color: #f3c4c4;
  background-color: #fff4f4;
}

.chip-label {
  display: block;
  font-size: 11px;
  color: #6b7a8d;
  line-height: 1.1;
}

.chip-value {
  font-size: 17px;
  font-weight: 700;
  color: #1d2b3a;
  line-height: 1.1;
}

.pulsus-summary-actions {
  margin-left: auto;
  display: flex;
  gap: 8px;
}

.pulsus-fail-icon {
  display: inline-block;
  margin-right: 6px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  border-radius: 50%;
  font-weight: 700;
  font-size: 11px;
  color: #8a1c1c;
  background-color: #ffd8d8;
}


.pulsus-table .col-vehicle {
  width: 31%;
}

.pulsus-devices-table {
  width: 100%;
  overflow: visible;
}

.vehicle-select {
  width: 100%;
  min-width: 0;
}

.pulsus-table {
  table-layout: fixed;
  width: 100%;
}

.pulsus-table th,
.pulsus-table td {
  white-space: normal;
  word-break: break-word;
  vertical-align: middle;
}

.pulsus-table th:first-child,
.pulsus-table td:first-child {
  width: 18%;
}

.pulsus-table th:nth-child(2),
.pulsus-table td:nth-child(2) {
  width: 14%;
}

.pulsus-table th:nth-child(3),
.pulsus-table td:nth-child(3) {
  width: 10%;
}

.pulsus-table th:nth-child(4),
.pulsus-table td:nth-child(4) {
  width: 7%;
}

.pulsus-table th:nth-child(6),
.pulsus-table td:nth-child(6) {
  width: 12%;
}

.pulsus-table th:nth-child(7),
.pulsus-table td:nth-child(7) {
  width: 8%;
}

::v-deep .vehicle-select .vs__dropdown-toggle {
  min-height: 38px;
}

::v-deep .vehicle-select .vs__dropdown-menu {
  min-width: 420px;
  max-height: 340px;
  z-index: 2100;
}

::v-deep .vehicle-select .vs__selected,
::v-deep .vehicle-select .vs__search {
  max-width: 100%;
}

@media (max-width: 992px) {
  .pulsus-modal-dialog {
    width: 96vw;
    max-width: 96vw;
    margin: 0.5rem auto;
  }

  .pulsus-modal-content {
    min-height: 86vh;
    overflow: visible;
  }

  .pulsus-modal-body {
    max-height: none;
    overflow: visible;
  }

  .pulsus-table .col-vehicle {
    min-width: 240px;
    width: 38%;
  }
}

.pulsus-confirm-check {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 12px;
  font-weight: 600;
}

.pulsus-confirm-check input {
  width: 15px;
  height: 15px;
}
</style>
